export enum EApiClientType {
	WEB = 'web',
	CRM = 'crm',
	PANEL = 'panel',
	IOS = 'ios',
	ANDROID = 'android',
	AI_CHAT = 'ai-chat',
	AI_VOICE = 'ai-voice',
}

export enum ESelectionSource {
	WEB = 'web',
	WEB_AI = 'web-ai',
	CRM = 'crm',
	IOS = 'ios',
	IOS_AI = 'ios-ai',
	ANDROID = 'android',
	ANDROID_AI = 'android-ai',
	AI_CHAT = 'ai-chat',
	AI_VOICE = 'ai-voice',
	BACKEND = 'backend',
	BACKEND_AI = 'backend-ai',
}
